import { property, State } from '@mfec/lit/store';
import type { TemplateTheme } from '@mfec/lit/TemplateResolver';

export class ConfigStore extends State {
  [key: string | symbol]: unknown;

  // The EIAM access token used by the agent in Marquez
  @property({ value: undefined }) accessToken?: string | undefined;

  // The URL of api4p to use
  @property({ value: undefined }) apiUrl!: string;

  // Service Provider ID and Local Customer ID
  @property({ value: undefined }) spId!: string;
  @property({ value: undefined }) lcId!: string;

  // Theme (default: occl)
  @property({ value: 'occl' }) theme!: TemplateTheme;

  // URL to fetch the resources for the theme from, eg.
  // https://dev-library.telefonica.de/1 or
  // https://library.telefonica.de/1
  @property({ value: undefined }) themeBaseUrl!: string;

  // alternative fetch method, needed by some salesforce clients
  @property({ value: undefined }) fetch?: string | undefined;

  // A traceid generated by the integrating portal or by COMS if not present
  @property({ value: crypto.randomUUID() }) traceid: string | undefined;
}

export const store = new ConfigStore();
